class GeolocationServiceImpl {
	private _cachedPosition: { lat: number; lng: number } | null = null;
	private _pendingRequest: Promise<{
		lat: number;
		lng: number;
	} | null> | null = null;
	private _error: string | null = null;

	public getCachedPosition(): { lat: number; lng: number } | null {
		return this._cachedPosition;
	}

	public getError(): string | null {
		return this._error;
	}

	public async requestPosition(): Promise<{
		lat: number;
		lng: number;
	} | null> {
		if (this._cachedPosition != null) {
			return this._cachedPosition;
		}
		if (this._pendingRequest != null) {
			return this._pendingRequest;
		}
		this._pendingRequest = new Promise((resolve) => {
			if (
				typeof navigator === 'undefined' ||
				// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
				navigator.geolocation == null
			) {
				this._error = 'Geolocation is not supported by this browser';
				resolve(null);
				return;
			}
			navigator.geolocation.getCurrentPosition(
				(position) => {
					this._cachedPosition = {
						lat: position.coords.latitude,
						lng: position.coords.longitude,
					};
					this._error = null;
					resolve(this._cachedPosition);
				},
				(err) => {
					this._error = err.message;
					resolve(null);
				},
				{ enableHighAccuracy: false, timeout: 10000 },
			);
		});
		const result = await this._pendingRequest;
		this._pendingRequest = null;
		return result;
	}
}

export const GeolocationService = new GeolocationServiceImpl();
